<template>
  <div>
      <p class="headerstyle">กรุณากรอกข้อมูลของแอดมิน</p>
      <p id='fadeIn' v-if="errors.length">
        <b>กรุณากรอกข้อมูลให้ถูกต้อง :</b>
          <ul>
            <li  v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </p>
      <div class="fromstyle">
        <form @submit.prevent="checkForm">
            <div class="flex justify-center h-full">
                 <Profile @Get-imgUrl='GetimgUrl' class="Profile-style" />
            </div>
         
          <br />
          <p v-show="!imgUrl" class="headerstyle">ใส่รูปแอดมิน</p>
          <vs-input
            class="w-full"
            id="FirstName"
            placeholder="ชื่อ"
            type="text"
            v-model="FirstName"
            name="FirstName"
            required
          />
          <br />
          <vs-input
            class="w-full"
            id="LastName"
            placeholder="นามสกุล"
            type="text"
            v-model="LastName"
            name="LastName"
            required
          />
          <br />
          <vs-input
            class="w-full"
            id="email"
            placeholder="อีเมล"
            type="email"
            v-model="email"
            name="email"
            required
          />
          <br />
          <vs-input
            class="w-full"
            id="phone"
            placeholder="เบอร์ติดต่อ"
            type="Tel"
            v-model="phone"
            name="phone"
            required
          />
          <br/>
          <vs-input
            class="w-full"
            id="password"
            placeholder="รหัสผ่าน"
            :type=Type
            v-model="password"
            name="password"
            required
          />
        
          <br />
          <vs-input
            class="w-full"
            id="confirm_password"
            placeholder="ยืนยันรหัสผ่าน"
            :type=Type
            v-model="confirm_password"
            name="confirm_password"
            required
          />
          <!-- <span class="pointer" @click="ToggleShowPassword()">
             <img v-if="ShowPassword == false" src="@/assets/images/elements/eye-open.svg" alt="">
             <img v-if="ShowPassword == true" src="@/assets/images/elements/eye-with-line.svg" alt="">
          </span> -->
          
         
          <br />
          <select class="mb-5 custom-select" v-model="admintype" id="admintype" name="admintype" required>
            <option value=null disabled selected>ตำแหน่ง</option>
            <option >super admin</option>
            <option >administrator</option>
          </select>
          <vs-row vs-w="12">
            <vs-col vs-w="12" class="flex justify-center">
              <button type="submit" value="Submit" class="share-btn">
                เพิ่มแอดมิน
              </button>
            </vs-col>
          </vs-row>
        </form>
      </div>
    </div>

</template>

<script>
import Profile from '@/views/elements/Profiletemplete.vue'
import axios from "../../../util/backend";
import baseUrl from '../../../util/baseUrl'

export default {
    components: {
        Profile,
    },
    data() {
        return {
            FirstName: null,
            LastName: null,
            email: null,
            admintype : null,
            password: null,
            confirm_password: null,
            imgUrl: null,
            errors:[],
            phone: null,
            ShowPassword: false,
            Type:'password'
        }
    },
    methods: {
        async checkForm(e) {
        this.errors = [];
        if(this.password !== this.confirm_password){
          this.errors.push("ยืนยันรหัสผ่านไม่ถูต้อง")
        }

         if (this.errors.length > 0) {
        for (const err of this.errors) {
          this.$vs.notify({
            title: "Error message",
            text: err,
            color: "danger",
            icon: "error",
            position: "top-right",
          });
        }
        return;
      }
        if (this.errors.length == 0) {
          this.$vs.loading()
        let config = {
          method: "post",
          url: `${baseUrl.baseurl()}/registerAdmin`,
          data: {
          
           first_name: this.FirstName.trimLeft(),
           last_name: this.LastName.trimLeft(),
           email: this.email,
           password: this.password,
           phone: this.phone,
           role: this.admintype,
           img_url: this.imgUrl? this.imgUrl : null
          
          },
        };
        await axios.api(config).then((res) => {
          this.$vs.loading.close()
         this.$vs.notify({
              title: "การสร้างแอดมิน",
              text: "สำเร็จ",
              color: "success",
              icon: "check_box",
              position: "top-right",
            });
         this.$router.push({ path: "/administrator" });
         
        })
        .catch((err)=>{
          this.$vs.loading.close()
          this.$vs.notify({
              title: "Error message",
              text: `${
                err.response.data.error ? err.response.data.error : err
              }`,
              color: "danger",
              icon: "error",
              position: "top-right",
            });
        })
      }

    },
        GetimgUrl(e){
            this.imgUrl = e
        },

      ToggleShowPassword(){
      if(this.ShowPassword){
        this.Type = 'password'
        this.ShowPassword = !this.ShowPassword
      }
      else {
        this.Type = 'text'
        this.ShowPassword = !this.ShowPassword
      }
      
    }
    },
    
   
};
</script>

<style lang="scss" scoped>
.headerstyle {
  color: #1a3683;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
  text-align: center;
}

.share-btn {
  background-color: #0430ad;
  padding: 10px 20px 10px 20px;
  border-radius: 10px;
  border-style: none;
  color: #ffff;

  &:hover {
    transition-delay: 100ms;
    background-color: #072c49;
  }
  &:active {
    background-color: #072c49;
  }
}
.Profile-style {
    height: 10rem;
    width: 10rem;
}
</style>
